<template>
  <router-link v-if="scheme" :to="{ name: 'hall_scheme', params: { id: scheme.id } }" class="hall-scheme-card">
    <div class="hall-scheme-card__shadow" />
    <ImgComponent :img="scheme.img" width="700" height="400" class="hall-scheme-card__image" />
    <div class="hall-scheme-card__content">
      <span v-if="scheme.title" class="hall-scheme-card__title">{{ scheme.title }}</span>
    </div>
  </router-link>
</template>

<script>
import ImgComponent from "components/ImgComponent.vue";

export default {
  name: "HallSchemeCardComponent",
  props: {
    scheme: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgComponent,
  },
};
</script>

<style lang="stylus">
.hall-scheme-card {
  max-height 350px
  border-radius 10px
  overflow hidden
  display flex
  align-items end
  position relative

  &__shadow {
    width 100%
    height 100%
    absolute left top
    background linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.81) 100%)
  }

  &__image {
    width 100%
    height 100%
  }

  &__content {
    position absolute
    padding 10px 15px
    display flex
    flex-direction column
    gap 10px
  }

  &__title {
    font-size 1.25rem
    font-weight 600
    line-height 1.75rem
    color var(--white)
  }
}
</style>
